import React, { FC } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material';
import { FieldRenderProps } from 'react-final-form';

type SelectOption = { label: string; value: string };

interface Props
  extends FieldRenderProps<SelectProps<SelectOption>, HTMLElement> {
  items: SelectOption[];
}

const SelectAdapter: FC<Props> = ({
  input: { onChange, value, ...restInput },
  items,
  label,
  margin,
  formControlProps,
  ...restProps
}) => (
  <FormControl fullWidth margin={margin} {...formControlProps}>
    <InputLabel>{label}</InputLabel>
    <Select
      value={value}
      onChange={onChange}
      inputProps={restInput}
      label={label}
      {...restProps}
    >
      {items.map(({ label: optionLabel, value: optionValue }) => (
        <MenuItem key={optionValue} value={optionValue}>
          {optionLabel}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default SelectAdapter;
